<template>
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2812 7.75C14.2812 11.1406 11.793 13.957 8.53906 14.4492V9.71875H10.125L10.4258 7.75H8.53906V6.49219C8.53906 5.94531 8.8125 5.42578 9.66016 5.42578H10.5078V3.75781C10.5078 3.75781 9.74219 3.62109 8.97656 3.62109C7.44531 3.62109 6.43359 4.57812 6.43359 6.27344V7.75H4.71094V9.71875H6.43359V14.4492C3.17969 13.957 0.71875 11.1406 0.71875 7.75C0.71875 4.00391 3.75391 0.96875 7.5 0.96875C11.2461 0.96875 14.2812 4.00391 14.2812 7.75Z"
      :fill="props.fill"
    />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  fill: {
    type: String,
    default: '#000000',
  },
});
</script>
